import type { SortDirection } from "@/types/common"
import type { TherapiesList, Therapy } from "@/types/therapy"
import { API_ROOT, HttpClient } from "@/api/httpClient"

export type TherapiesListSortKey = "date" | "start" | "end"

export interface TherapiesListQuery {
	perPage: number
	page: number
	sort?: {
		key?: TherapiesListSortKey
		direction?: SortDirection
	}
	filters?: {
		/** cerca in: drug */
		text?: string
		active?: boolean
	}
}

interface TherapiesListParams {
	paginate: true
	per_page: number
	page: number
	sort_key?: TherapiesListSortKey
	sort_dir?: SortDirection
	searchTerm?: string
	active?: 0 | 1
}

export type TherapyPayload = Omit<Therapy, "id" | "created_at" | "updated_at">

export default {
	list(patientId: number, payload?: TherapiesListQuery) {
		const params: TherapiesListParams = {
			paginate: true,
			per_page: payload?.perPage || 50,
			page: payload?.page || 1,
			sort_dir: payload?.sort?.direction || "desc",
			sort_key: payload?.sort?.key || "date"
		}

		if (payload?.filters?.text !== undefined) {
			params.searchTerm = payload.filters.text
		}

		if (payload?.filters?.active !== undefined) {
			params.active = payload.filters.active ? 1 : 0
		}

		return HttpClient.get<TherapiesList>(`${API_ROOT}/patients/${patientId}/therapies`, {
			params
		})
	},
	create(patientId: number, payload: TherapyPayload) {
		return HttpClient.post<Therapy>(`${API_ROOT}/patients/${patientId}/therapies`, payload)
	},
	update(patientId: number, therapyId: number, payload: TherapyPayload) {
		return HttpClient.put(`${API_ROOT}/patients/${patientId}/therapies/${therapyId}`, payload)
	},
	details(patientId: number, therapyId: number) {
		return HttpClient.get<Therapy>(`${API_ROOT}/patients/${patientId}/therapies/${therapyId}`)
	},
	delete(patientId: number, therapyId: number) {
		return HttpClient.delete(`${API_ROOT}/patients/${patientId}/therapies/${therapyId}`)
	}
}
